import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "person-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8 8.5c3.314 0 6 2.058 6 4.596 0 2.539-12 2.539-12 0C2 10.558 4.686 8.5 8 8.5zM8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
